import React from 'react';
import Dashboard from '../../Pages/Dashboard/Dashboard';

function DashboardRoute() {
    return (
        <Dashboard />
    );
}

export default DashboardRoute;
